$('#goTop').click(function(){
	$('html, body').animate({
		scrollTop: 0
	}, 1000);

	$(this).blur();
});

let goTop = {};

goTop.jaVerify 	= false;
goTop.verify 	= function(){
	let w = $(window).scrollTop();
	
	if(w >= 150) {
		$('#goTop').addClass('active');
	}else{
		$('#goTop').removeClass('active');
	}
}
goTop.autostart = (function(){
	goTop.verify();

	$(window).scroll(function(){
		if(goTop.jaVerify) return;

		setTimeout(function(){
			goTop.jaVerify =  false;
		}, 100);

		goTop.verify();
	});
})();